function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, $helpers, Array, Object) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-sh-explains-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        const segments = $component.alert.explains;;
        const segmentsLength = segments.length;;
        const segmentsType = $helpers.getSegmentsType();;
        const segmentsMessage = $helpers.getSegmentsMessage();;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-shared-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Driving Segments");;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-shared-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-explains-text': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("span", {
              "class": {
                'mp-sh-alert-keyword': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("" + (segmentsLength) + " " + (segmentsType) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(" " + (segmentsMessage) + "");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-explains-segments-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (segments);
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, segment, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("a", {
                      "attrs": {
                        href: segment.generatePermalink()
                      },
                      "on": {
                        click: event => $helpers.handleClickSegmentsLink(event, segment)
                      },
                      "class": Object.assign({}, {
                        'mp-sh-explains-selected': $helpers.isSelectedExplains(segment)
                      }, {
                        'mp-sh-explains-link': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-sh-explains-type-icon': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                          "attrs": {
                            icon: $helpers.getIcon(segment)
                          },
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-sh-explains-link-text': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        const formattedProperty = $helpers.getFormattedProperty(segment.property);
                        __jade_nodes = __jade_nodes.concat("" + (formattedProperty) + " = " + (segment.propertyValue) + "");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-sh-explains-strength': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        const strength = $helpers.getSegmentStrength(segment.priority);
                        __jade_nodes = __jade_nodes.concat("" + (strength) + "");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var segment = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("a", {
                          "attrs": {
                            href: segment.generatePermalink()
                          },
                          "on": {
                            click: event => $helpers.handleClickSegmentsLink(event, segment)
                          },
                          "class": Object.assign({}, {
                            'mp-sh-explains-selected': $helpers.isSelectedExplains(segment)
                          }, {
                            'mp-sh-explains-link': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-sh-explains-type-icon': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": {
                                icon: $helpers.getIcon(segment)
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-sh-explains-link-text': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            const formattedProperty = $helpers.getFormattedProperty(segment.property);
                            __jade_nodes = __jade_nodes.concat("" + (formattedProperty) + " = " + (segment.propertyValue) + "");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-sh-explains-strength': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            const strength = $helpers.getSegmentStrength(segment.priority);
                            __jade_nodes = __jade_nodes.concat("" + (strength) + "");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;